import { createContext, useContext } from 'react'
import { getEmailBranding } from '.'

const defaultEmailBranding = getEmailBranding()

export const EmailBrandingContext = createContext(defaultEmailBranding)

export const useEmailBrandingContext = () => useContext(EmailBrandingContext)
